module.exports = __webpack_public_path__ + "baa53d276c06d229f02ad1a9a78cdd91.svg";